import { Injectable, NgZone, inject } from '@angular/core';

/** Ile ostatnia interakcja „żyje” — po tym czasie bez ruchu karta przestaje być aktywna. */
const ACTIVE_WINDOW_MS = 60_000;

/**
 * Czy użytkownik naprawdę korzysta z aplikacji — podstawa naliczania Cryptionis Token.
 *
 * Aktywny = karta widoczna ORAZ była interakcja (ruch myszy, klawisz, przewinięcie, dotyk)
 * w ostatniej minucie. Otwarta w tle karta albo komputer bez użytkownika nie zbiera tokenów.
 * Słuchacze działają poza strefą Angulara (bez detekcji zmian przy każdym ruchu myszy).
 */
@Injectable({ providedIn: 'root' })
export class ActivityTrackerService {
	private _last = Date.now();
	private _started = false;
	private readonly _zone = inject(NgZone);

	start(): void {
		if (this._started || typeof window === 'undefined') {
			return;
		}

		this._started = true;
		const mark = (): void => {
			this._last = Date.now();
		};
		this._zone.runOutsideAngular(() => {
			for (const ev of [
				'pointermove',
				'pointerdown',
				'keydown',
				'wheel',
				'scroll',
				'touchstart',
			]) {
				window.addEventListener(ev, mark, { passive: true, capture: true });
			}
		});
	}

	isActive(): boolean {
		return (
			typeof document !== 'undefined' &&
			document.visibilityState === 'visible' &&
			Date.now() - this._last < ACTIVE_WINDOW_MS
		);
	}
}
